import AgyleDialog from "../../components/modal/agyleDialog";
import * as React from "react";


function FHIRViewJson (props) {

    const fhirJsonMessage = () => {
        return JSON.stringify(props.message, null, 2)

    }

    return (  <AgyleDialog
        title={"FHIR JSON Message"}
        open={props.isOpen}
        onClose={props.handleCloseModal}
        width={"lg"}
        fullWidth
        disableSave
    >
        <pre> {fhirJsonMessage()} </pre>
    </AgyleDialog>)
}

export default FHIRViewJson